import type React from "react";

export const ButtonVariant = {
	CONTAINED: "contained",
	OUTLINED: "outlined",
	TEXT: "text",
} as const;

export type ButtonVariant = (typeof ButtonVariant)[keyof typeof ButtonVariant];

export const ButtonSize = {
	SMALL: "small",
	MEDIUM: "medium",
	LARGE: "large",
} as const;

export type ButtonSize = (typeof ButtonSize)[keyof typeof ButtonSize];

export interface ButtonProps
	extends React.ButtonHTMLAttributes<HTMLButtonElement> {
	variant?: ButtonVariant;
	size?: ButtonSize;
	fullWidth?: boolean;
	loading?: boolean;
}
